export default __webpack_public_path__ + "static/badgerbalm-4242a35f4149375800bceac574c2e697.png";